import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createUserInvitationApi } from '../../users/api/invitation.api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useResendDriverInvitation(): UseMutationResult<void, Error, string> {
  const client = useApiClient('admin-auth');
  const api = createUserInvitationApi(client);
  const { t } = useTranslation('settings');

  return useMutation<void, Error, string>({
    mutationFn: (email: string) => api.resendInvitationByEmail(email),
    ...createMutationCallbacks({
      errorKey: 'drivers.toast.resendError',
      successKey: 'drivers.toast.resendSuccess',
      t,
    }),
  });
}
